import { UpstreamPullStrategyTypeId as UpstreamPullStrategyTypeId$1, PullAfterNext as PullAfterNext$1, PullAfterAllEnqueued as PullAfterAllEnqueued$1, isUpstreamPullStrategy as isUpstreamPullStrategy$1, isPullAfterNext as isPullAfterNext$1, isPullAfterAllEnqueued as isPullAfterAllEnqueued$1, match as match$1 } from '../../internal/channel/upstreamPullStrategy.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const UpstreamPullStrategyTypeId = UpstreamPullStrategyTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const PullAfterNext = PullAfterNext$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const PullAfterAllEnqueued = PullAfterAllEnqueued$1;

/**
 * Returns `true` if the specified value is an `UpstreamPullStrategy`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isUpstreamPullStrategy = isUpstreamPullStrategy$1;

/**
 * Returns `true` if the specified `UpstreamPullStrategy` is a `PullAfterNext`,
 * `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isPullAfterNext = isPullAfterNext$1;

/**
 * Returns `true` if the specified `UpstreamPullStrategy` is a
 * `PullAfterAllEnqueued`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isPullAfterAllEnqueued = isPullAfterAllEnqueued$1;

/**
 * Folds an `UpstreamPullStrategy<A>` into a value of type `Z`.
 *
 * @since 2.0.0
 * @category folding
 */
const match = match$1;

export { PullAfterAllEnqueued, PullAfterNext, UpstreamPullStrategyTypeId, isPullAfterAllEnqueued, isPullAfterNext, isUpstreamPullStrategy, match };
